import { Button, Row } from 'antd';
import styled from 'styled-components';

export const DescriptionRow = styled(Row)`
  padding: 12px 20px;
  margin-bottom: 20px;
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #858585;
  text-align: center;

  margin: 0;
`;

export const ButtonRow = styled(Row)`
  padding: 0 40px;
`;

export const CancelButton = styled(Button)`
  height: 44px;
  border: 1px solid #ededed;
  border-radius: 4px;
  color: #333333;

  font-size: 14px;
  font-weight: 700;
  line-height: 19px;

  padding: 12px 20px;

  &:hover,
  &:active,
  &:focus {
    color: #333333;
    border-color: #ededed;
  }

  &::after {
    box-shadow: 0 0 0 0 #000000 !important;
  }
`;

export const ConfirmButton = styled(Button)`
  height: 44px;
  color: #ffffff;
  border-radius: 4px;

  font-size: 14px;
  font-weight: 700;
  line-height: 19px;

  padding: 12px 20px;
`;
